function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from './IconBase';

var IconTaskMediumOutline = function IconTaskMediumOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24"
  }, props, {
    width: "24",
    height: "24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 7a1 1 0 112 0v13a2 2 0 01-2 2H6a2 2 0 01-2-2V7a1 1 0 012 0v13h12V7zm-8 4h4a1 1 0 110 2h-4a1 1 0 110-2zm0 4h4a1 1 0 110 2h-4a1 1 0 110-2zm.268-12a2 2 0 013.464 0H14a2 2 0 012 2v2a1 1 0 01-1 1H9a1 1 0 01-1-1V5a2 2 0 012-2h.268zM10 5v1h4V5h-4zm2-1a1 1 0 00-1 1h2a1 1 0 00-1-1z"
  }));
};

export default IconTaskMediumOutline;